import {queryDefCode} from "@/api/projectManager_self";
import requests from "@/utils/requests_self";
import JsBridgeNew from "@/utils/jsbridgeNew";
import appService from "@/utils/appService";
class Service {
  static activityCode = 'carbonCredit';
  static collectionId = 312;

  static mock = false
  /**
   * @description 获取文交所藏品初始化数据
   * @param {*} params
   * @returns
   */
  static getInitData = async (params = {}) => {
    params = {activityCode: Service.activityCode}
    return await requests.post('/customer/activity/v1/initActivity', JSON.stringify(params));
  }

  /**
   * @description 获取藏品兑换信息
   * @param {*} params
   * @returns
   */
  static getRecData = async () => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const params = {
      activityCode: Service.activityCode,
      clientId: userInfo?.clientId
    }
    return await requests.post('/customer/activity/v1/getRecData', JSON.stringify(params));
  }

  /**
   * @description 检验藏品信息
   * @param {*} params
   * @returns
   */
  static checkRecData = async (nftNo) => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const params = {
      activityCode: Service.activityCode,
      clientId: userInfo?.clientId,
      nftNo
    }
    return await requests.post('/customer/activity/v1/checkRecData', JSON.stringify(params));
  }

  /**
   * @description 欧皇获取兑换码
   * @param {*} params
   * @returns
   */
  static GetRedeemCode = async () => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const params = {
      activityCode: Service.activityCode,
      flag:"badge",
      clientId: userInfo?.clientId,
    }
    return await appService("600935",params, false);
  }

  /**
   * @description 去兑换
   * @param {*} params
   * @returns
   */
  static recColl = async (nftNoList) => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const params = {
      activityCode: Service.activityCode,
      clientId: userInfo?.clientId,
      nftNoList
    }
    return await requests.post('/customer/recoveryActivity/v1/recColl', JSON.stringify(params));
  }

  /**
   * @description 获取文交所藏品初始化数据
   * @param {*} params
   * @returns
   */
  static getGoodsData = async (params = {},nftNo) => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    params = {
      activityCode: Service.activityCode,
      clientId: userInfo?.clientId,
      collectionId: userInfo?.collectionId,
      nftNo,
    }
    return await appService("600114",params, false);
  }
  /**
   * @description 商品详情
   * @param {*} params
   * @returns
   */
  static getGoodsDetail = async (params) => {
    return await requests.post('/customer/purchase/v1/getCollectionDetail', JSON.stringify(params));
  }
  /**
   * @description 领取记录
   * @param {*} params
   * @returns
   */
  static getRecordsData = async (pageNum = 1) => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const params = {
      activityCode: Service.activityCode,
      clientId: userInfo?.clientId,
      remark: '3',
      pageNum: pageNum,
      pageSize:10,
    }
    return await appService("600929",params, false);
  }
  /**
   * @description 检验兑换码
   * @param {*} params
   * @returns
   */
  static checkRedeemCode = async (redeemCode) => {
    const params = {
      activityCode: Service.activityCode,
      redeemCode: redeemCode,
    }
    return await appService("600931",params, false);
  }
  /**
   * @description 获取活动规则
   * @param {*} params
   * @returns
   */
  static getActivityRules = async () => {
    return await queryDefCode({codeType: 'activityRule', code: Service.activityCode});
  }

  /**
   * @description 获取用户信息，是否实名
   * @returns {ID: 存在则实名}
   */
  static getUserCertificateStatus = async () => {
    if (window.JsBridge.hasWebViewBridge()) {
      const res = await window.JsBridge.getDetailCurrentUserInfo()
      return res;
    } else {
      return {};
    }
  }
  /**
   * @description 验证用户是否拥满足领取条件
   * @param {*} params
   * @returns
   */
  static meetClaimService = async () => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const params = {
      clientId: userInfo.clientId,
    }
    if(Service.mock){
      return {
        "code": "000000",
        "data": {
          "248": {
            "imageBg": "https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/luBadge.png?Lubadge-0004",
            "num": 1,
            "collectionId": 248,
            "collectionName": "无锡"
          },
          "249": {
            "imageBg": "https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/fuBadge.png?Fubadge-0013",
            "num": 2,
            "collectionId": 249,
            "collectionName": "徐州"
          },
          "230": {
            "imageBg": "https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/fuBadge.png?Fubadge-0013",
            "num": 2,
            "collectionId": 230,
            "collectionName": "徐州"
          },
          "-1": {
            "redeemable": false,
            "isHas": false
          },
        },
        "msg": null
      }
    }
    return await requests.post('/customer/claim/meetClaim', JSON.stringify(params));
  }
  /**
   * @description 用户领取13太保集齐奖励藏品
   */
  static receiveService = async () => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const params = {
      clientId: userInfo.clientId,
    }
    return await requests.post('/customer/claim/receive', JSON.stringify(params));
  }
  /**
   * @description 用户购买权限校验
   */
  static purchasePermissions = async () => {
    const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    const params = {
      clientId: userInfo.clientId,
      collectionId: Service.collectionId,
      activityCode: Service.activityCode,
    }
    return await requests.post('/customer/claim/purchasePermissions', JSON.stringify(params));
  }
  /**
 * @description 用户领取奖
 * @param {*} params
 * @returns
 */
    static receiveReward = async (claimType) => {
      const userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
      const params = {
        clientId: userInfo.clientId,
        claimType: claimType,
        activityCode: Service.activityCode,
      }
      return await requests.post('/customer/claim/getCollect', JSON.stringify(params));
    }

     /**
   * @description 获取申请列表
   * @param {*} params
   * @returns
   */
  static getApprovalList = async (pageNum) => {
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const params = {
      clientId: userInfo?.clientId,
      pageNum: pageNum,
      pageSize:10,
    }
    return await requests.post('/customer/carbon/approvalList', JSON.stringify(params));
  }

    /**
   * @description 申请初始化
   * @param {*} params
   * @returns
   */
    static getAddInit = async () => {
      const params = {
        activityCode: Service.activityCode,
      }
      return await requests.post('/customer/carbon/addInit', JSON.stringify(params));
    }

    /**
   * @description 申请详情
   * @param {*} params
   * @returns
   */
    static getApprovalDetail = async (id) => {
      return await requests.get('/customer/carbon/detail/'+id);
    }

     /**
   * @description 获取碳权预支付信息
   * @param {*} params
   * @returns
   */
     static getCarbonProductPrepaid = async () => {
      const params = {
        activityCode: Service.activityCode,
        source:'app'
      }
      return await requests.post('/customer/purchase/v1/getCarbonProductPrepaid', JSON.stringify(params));
    }

     /**
   * @description 碳权申请订单
   * @param {*} params
   * @returns
   */
     static postConfirmSimpleOrder = async (params) => {
      return await requests.post('/customer/order/v1/confirmSimpleOrder', JSON.stringify(params));
    }


}

export default Service;